// The kinds of person the streamer can introduce on the ticker. `value` is the backend's `PersonType` enum name
// (CricCenterEC2 `PersonType`), `label` what the dashboard shows. Keep the two lists in step.
export interface PersonTypeOption {
  value: string;
  label: string;
}

export const PERSON_TYPES: PersonTypeOption[] = [
  { value: "COMMENTATOR", label: "Commentator" },
  { value: "UMPIRE", label: "Umpire" },
  { value: "TV_UMPIRE", label: "TV Umpire" },
  { value: "MATCH_REFEREE", label: "Match Referee" },
  { value: "SCORER", label: "Scorer" },
  { value: "ANCHOR", label: "Anchor" },
  { value: "EXPERT", label: "Expert" },
  { value: "GUEST", label: "Guest" },
];

// Longest name the ticker's one-line name pill holds (the backend rejects more).
export const MAX_PERSON_NAME_LENGTH = 60;

// What is sent: the name trimmed, or null while it can't be shown (blank, or a type that isn't in the list).
export function toPersonIntro(name: string, type: string): { personName: string; personType: string } | null {
  const personName = name.trim();
  if (!personName || personName.length > MAX_PERSON_NAME_LENGTH) return null;
  if (!PERSON_TYPES.some((option) => option.value === type)) return null;
  return { personName, personType: type };
}
